import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'videotestAngular';

  @ViewChild('brightcoveContainer', { static: true }) container!: ElementRef;

      ////////////////////////////////// ISI CODE START /////////////////////////////
 
  ngAfterViewInit(): void {
  
 
 
       // Create div element
    const videoDiv = document.createElement('div');
    videoDiv.setAttribute('data-experience', '646cd58200c9590025cfe652');
 
    // Append div
    this.container.nativeElement.appendChild(videoDiv);
 
    // Load script
    const script = document.createElement('script');
    //script.src = 'https://players.brightcove.net/5848624617001/experience_646cd58200c9590025cfe652/live.js';
    script.src='https://players.brightcove.net/5848624617001/experience_646cd58200c9590025cfe652/live.js';
    script.async = true;
 
    this.container.nativeElement.appendChild(script);
  }
}
